<div class="send-offer-banner">
    <img *ngIf="imageSrc"
         [src]="imageSrc"
         alt=""
         class="send-offer-banner__image"
    >

    <div class="send-offer-banner__content">
        <div class="send-offer-banner__left">
            <span class="send-offer-banner__left__text">
                {{ 'HEADER.SEND_OFFER.LABEL' | translate }}
            </span>
            <img class="send-offer-banner__left__icon"
                 [src]="mailIconSrc"
                 alt=""
            >
        </div>

        <button class="btn btn--small send-offer-banner__button"
                (click)="mailOffer()">
            {{ 'HEADER.SEND_OFFER.MAIL' | translate }}
        </button>
    </div>
</div>
